<template>
  <div id="ORDER_OVERVIEW" class="container-fluid">
    <div v-if="isDisabled" class="container-fixed text-center offset-top-6" v-html="$t('order.disabled')" />
    <template v-else>
      <VContractCustomerTabs locale-namespace="order" @change="onTabChange" />
      <div class="grayed">
        <div class="container-fixed grayed-offset">
          <transition name="fade" mode="out-in" appear>
            <div v-if="isEmpty" key="empty" class="offset-top-12" />
            <VSpinner v-else-if="isLoading" key="spinner" class="offset-top-2" />
            <div v-else key="data">
              <VGrid :items="openOrders">
                <template #label>
                  {{ $t('order.open_orders') }}
                </template>
                <template #item="{ item }">
                  <VItem :item="item" />
                </template>
                <template #empty>
                  <div class="h-ctr v-ctr offset-top-3 offset-bottom-3">
                    {{ $t('order.empty') }}
                  </div>
                </template>
              </VGrid>

              <VGrid :items="closedOrders" hide-empty>
                <template #label>
                  {{ $t('order.closed_orders') }}
                </template>
                <template #item="{ item }">
                  <VItem :item="item" />
                </template>
              </VGrid>
            </div>
          </transition>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import partition from 'lodash/partition';
import TitleMixin from '@/mixins/title';
import Proxy from '@/proxies/SubstoreOrderOverviewProxy';
import VSpinner from '@/components/Spinner';
import VItem from '@/components/Substore/OrderOverview/Item';
import VGrid from '@/components/Substore/OrderOverview/Grid';
import VContractCustomerTabs from '@/components/UI/Tabs/ContractCustomerTabs';

export default {
  name: 'OrderOverview',

  components: {
    VSpinner,
    VGrid,
    VItem,
    VContractCustomerTabs,
  },

  mixins: [TitleMixin],

  data() {
    return {
      openOrders: [],
      closedOrders: [],
      activeTab: null, // See de.scoopgmbh.cap.substore.service.provider.api.IdentifierContext

      /** may be 'EMPTY', 'LOADING' or 'LOADED' */
      state: 'EMPTY',
    };
  },

  computed: {
    ...mapGetters('system', ['isContractSearchAllowed', 'isCustomerSearchAllowed']),

    ...mapState('contract', ['contractHash']),

    ...mapState('customer', ['customerHash']),

    isDisabled() {
      return !this.contractHash && !this.customerHash && !this.isContractSearchAllowed && !this.isCustomerSearchAllowed;
    },

    isEmpty() {
      return this.state === 'EMPTY';
    },

    isLoading() {
      return this.state === 'LOADING';
    },
  },

  methods: {
    async onTabChange(tab) {
      this.state = 'LOADING';
      const response = await new Proxy().find(tab);

      const [closedOrders, openOrders] = partition(response.data.data, i => ['COMPLETED', 'NOT_COMPLETED', 'CANCELED'].includes(i.orderStatus));
      this.openOrders = Object.freeze(openOrders);
      this.closedOrders = Object.freeze(closedOrders);
      this.state = 'LOADED';
    },
  },
};
</script>
